export default {"src":"/_next/static/media/WhoWeAre_004A.a1a4469c.JPG","height":684,"width":1920};